import { render } from "./RicontattiComponent.vue?vue&type=template&id=5ba0092c&scoped=true"
import script from "./RicontattiComponent.vue?vue&type=script&lang=js"
export * from "./RicontattiComponent.vue?vue&type=script&lang=js"

import "./RicontattiComponent.vue?vue&type=style&index=0&id=5ba0092c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba0092c"]])

export default __exports__